export default "__VITE_ASSET__CL9tQc5J__"